export default "__VITE_ASSET__PIKc9AGh__"